import config from 'config';
import store from '../store';

class Utils {

	/**
	 * Insert msisdn prefix when not exists
	 * @params msisdn
	 * @returns {string}
	 */
	static insertMsisdnPrefix(msisdn){
		if (!msisdn || (typeof msisdn !== "string" && typeof msisdn !== "number")) return null;
		if (msisdn.substr(0,2) == config.application.countryConfig.countryPrefix) return msisdn;

		return config.application.countryConfig.countryPrefix + msisdn;
	}

	/**
	 * Remove msisdn prefix when exists
	 * @params msisdn
	 * @returns {string}
	 */
	static removeMsisdnPrefix(msisdn){
		if (!msisdn || (typeof msisdn !== "string" && typeof msisdn !== "number")) return;

		if (msisdn.substr(0,2) == config.application.countryConfig.countryPrefix){
			return msisdn.substr(2,msisdn.length);
		}

		return msisdn;
	}

	/**
	 * Returns only the numbers in string
	 * @returns {string}
	 */
	static onlyNumbers(string) {
		return string.replace(/\D+/g, '');
	}

	/**
	 * get image path
	 * @returns {string}
	 */
	static getImgPath() {
		return config.application.imgPath;
	}

	/**
	 * Runs through an array of msisdn alias
	 * @param headers
	 * @returns {msisdn or null}
	 */
	static getMsisdnInHeader(headers){
		let HE = config.application.headersEnrichment;
		let val = null;

		for (let value of HE){
			if (headers[value]) val = headers[value];
		}

		return val;
	}

	/**
	 * Generates a random number between or equal the params
	 * @param min:int, max:int
	 * @returns int
	 */
	static getARandomInteger(min, max){
		min = Math.ceil(min);
		max = Math.floor(max+1);
		return Math.floor(Math.random() * (max - min)) + min;
	}

	/**
	 * Sets a temporary class to an especific dom node by Id
	 * @param className:string, time:int:ms, id:string
	 */
	static setTemporaryClass(className, time, id){
		if (document.getElementById(id))
			document.getElementById(id).className += " " + className;
		setTimeout(() => {
			if (document.getElementById(id))
				document.getElementById(id).className = document.getElementById(id).className.replace(" "+className, "");
		}, time);
	}

	/**
	 * Move scroll to loginForm when redirected from the Ticiket or Game pages
	 * Move scroll to page top when the in pages redirected
	 */
	static scrollGoToTop(path){
		let x = (path.state && path.state.scrollX) ? path.state.scrollX : 0;
		let y = (path.state && path.state.scrollY) ? path.state.scrollY : 0;

		setTimeout(() => {
			window.scrollTo(x,y);
		}, config.application.secureTransitionPageTime);
	}

	/**
	 * Get a value from localStorage by the key
	 */
	static getLocalStorage(key){
		return JSON.parse(localStorage.getItem(key));
	}

	/**
	 * Insert value into localStorage
	 */
	static setLocalStorage(key, value){
		localStorage.setItem(key, JSON.stringify(value));
	}

	/**
	 * Send data to Google Analytics
	 * @param category
	 * @param action
	 * @param label
	 * @param value
	 */
	static gaSend(category, action, label, value){
		category = (store.getState().userState.connectionType) ?
			store.getState().userState.connectionType + ': ' + category :
			category;

		if (!ga) return;
		ga('send', 'event', category, action, label, value);
	}
}

export default Utils;



// WEBPACK FOOTER //
// ./src/utils/utils.js